exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.Order__container__jzPif {\n  padding: 70px 0 30px 0; }\n", ""]);

// exports
exports.locals = {
	"container": "Order__container__jzPif"
};